import { useState } from 'react';
import { Card, Container, Divider, Table, TableBody, TableContainer, Tabs } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useQuery } from '@tanstack/react-query';
import { PATH_MANAGEMENT } from '../../../routes/paths';
import useSettings from '../../../hooks/useSettings';
import Page from '../../../components/Page';
import Scrollbar from '../../../components/Scrollbar';
import HeaderBreadcrumbs from '../../../components/HeaderBreadcrumbs';
import useTable from '../../../hooks/useTable';
import Layout from '../../../layouts';
import { TableHeadCustom, TableNoData, TableSkeleton } from '../../../components/table';
import { GeoTableToolbar } from '../../../sections/@dashboard/geofance/list';
import { getClosureShops } from '../../../services/shopServices';
import useTableData from '../../../hooks/useTableData';
import RemotePagination from 'src/components/pagination/RemotePagination';
import ClosureShopsRow from 'src/sections/@dashboard/managements/closure-shops/ClosureShopsRow';

const storedRowsPerPage = parseInt(localStorage.getItem('storedPaginate') ?? 5);

const INITIAL_VALUES = {
  paginate: storedRowsPerPage,
  page: 1,
  filter_by_holidays: true,
  name: 'all',
  status: 'accepted',
};

ClosureShops.getLayout = function getLayout(page) {
  return <Layout>{page}</Layout>;
};
export default function ClosureShops() {
  const { themeStretch } = useSettings();
  const { t } = useTranslation();
  const [filterValue, setFilterValue] = useState(INITIAL_VALUES);
  const [filterName, setFilterName] = useState('');

  const { isLoading, data, refetch } = useQuery(['allShops', filterValue], () => getClosureShops(filterValue));

  const [tableData, setTableData] = useTableData(data?.data?.data?.shops?.data);

  const { dense, order, orderBy, setPage, selected } = useTable({ defaultOrderBy: 'priority' });

  const TABLE_HEAD = [
    { id: 'created_at', label: 'تاریخ ایجاد' },

    { id: 'descriptions', label: 'توضیحات' },
    { id: 'start_at', label: 'تاریخ شروع' },
    { id: 'end_at', label: 'تاریخ پایان' },
    { id: 'shop_name', label: 'نام فروشگاه' },
    { id: 'user', label: 'نام' },
    { id: 'user_name', label: 'نام کاربر' },
  ];

  const handleFilterName = (filterName) => {
    const searchName = filterName.replace(/ي/g, 'ی').replace(/ك/g, 'ک');
    const newFilterValue = {
      ...filterValue,
      name: searchName,
    };

    setFilterName(searchName);
    setFilterValue(newFilterValue);
    setPage(1);
    refetch();
  };

  return (
    <Page title="تعطیلی واحدها">
      <Container maxWidth={themeStretch ? false : 'lg'}>
        <HeaderBreadcrumbs
          heading={'تعطیلی واحدها'}
          links={[
            {
              name: t('Managements'),
              href: PATH_MANAGEMENT.management.shops,
            },
            { name: 'تعطیلی واحدها' },
          ]}
          action={''}
        />
        <Card>
          <Divider />
          <GeoTableToolbar onFilterName={handleFilterName} setFilterValue={setFilterValue} filterValue={filterValue} />

          <Scrollbar>
            <TableContainer sx={{ minWidth: 800, position: 'relative' }}>
              <Table size={dense ? 'small' : 'medium'}>
                <TableHeadCustom
                  order={order}
                  orderBy={orderBy}
                  headLabel={TABLE_HEAD}
                  rowCount={tableData.length}
                  numSelected={selected.length}
                />

                <TableBody>
                  {isLoading && <TableSkeleton count={TABLE_HEAD.length} />}
                  {!isLoading && <TableNoData isNotFound={tableData?.length <= 0} />}
                  {tableData?.map((row) => (
                    <ClosureShopsRow key={row.id} row={row} />
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Scrollbar>
        </Card>

        <RemotePagination
          filterValue={filterValue}
          setFilterValue={setFilterValue}
          totalPage={data?.data?.data?.shops?.meta?.last_page}
          totalCount={data?.data?.data?.shops?.meta?.total}
        />
      </Container>
    </Page>
  );
}
